import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { acceptTerms, getTerms } from '@/lib/api';
import { useLogger } from '@/lib/hooks/useLogger';
import { authActions } from '@/state/auth';

export enum TermsState {
    INIT,
    LOADING,
    ERROR,
    LOADED,
}

export interface UseAcceptTermsData {
    acceptTerms: () => void;
    fetchTerms: () => void;
    terms: string;
    termsState: TermsState;
}

export const useAcceptTerms = (): UseAcceptTermsData => {
    const dispatch = useDispatch();
    const log = useLogger({ hook: 'useAcceptTerms' });

    const [terms, setTerms] = useState('');
    const [termsState, setTermsState] = useState<TermsState>(TermsState.INIT);

    const _acceptTerms = useCallback(async () => {
        try {
            const { user } = await acceptTerms();
            log.info('terms accepted', { user });
            dispatch(authActions.acceptTerms({ user }));
        } catch (e) {
            log.error('error accepting terms', {}, e);
            setTermsState(TermsState.ERROR);
        }
    }, [dispatch, log]);

    const fetchTerms = useCallback(async () => {
        try {
            setTermsState(TermsState.LOADING);
            const { terms } = await getTerms();
            setTerms(terms);
            setTermsState(TermsState.LOADED);
        } catch (_e) {
            // FIXME log error
            setTermsState(TermsState.ERROR);
        }
    }, []);

    return {
        acceptTerms: _acceptTerms,
        fetchTerms,
        terms,
        termsState,
    };
};
